import { ThemeDefinition } from 'vuetify';

export const nativeLanguage: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#bd2828',
    'on-subject-original': '#ffffff',
    subject: '#9c2121',
    'on-subject': '#ffffff',
    primary: '#761919',
    'on-primary': '#ffffff',
    'primary-container': '#f2c0c0',
    'on-primary-container': '#320b0b',
    secondary: '#644a4a',
    'on-secondary': '#ffffff',
    'secondary-container': '#ded3d3',
    'on-secondary-container': '#231a1a',
    surface: '#fcf7f7',
    'on-surface': '#201d1d',
    'on-surface-medium': '#4f4848',
    'on-surface-low': '#9e9494',
    outline: '#867979',
    'outline-variant': '#cfcaca',
    'inverse-surface': '#541212',
    'inverse-on-surface': '#fbeaea',
    'inverse-primary': '#edabab',
    'surface-dim': '#ebc2c2',
    'surface-bright': '#fefbfb',
    'surface-container-lowest': '#ffffff',
    'surface-container-low': '#faf0f0',
    'surface-container': '#f7e8e8',
    'surface-container-high': '#f2d9d9',
    'surface-container-highest': '#f0d1d1',
  },
};

export const nativeLanguageDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#bd2828',
    'on-subject-original': '#fdf7f7',
    subject: '#ea9e9e',
    'on-subject': '#320b0b',
    primary: '#f3c4c4',
    'on-primary': '#320b0b',
    'primary-container': '#7e1b1b',
    'on-primary-container': '#fdf7f7',
    secondary: '#dacdcd',
    'on-secondary': '#231a1a',
    'secondary-container': '#584141',
    'on-secondary-container': '#fbf9f9',
    surface: '#181010',
    'on-surface': '#f3f2f2',
    'on-surface-medium': '#cfc9c9',
    'on-surface-low': '#867979',
    outline: '#9e9494',
    'outline-variant': '#6b6161',
    'inverse-surface': '#eddede',
    'inverse-on-surface': '#281515',
    'inverse-primary': '#541212',
    'surface-dim': '#150e0e',
    'surface-bright': '#462f2f',
    'surface-container-lowest': '#120c0c',
    'surface-container-low': '#1e1515',
    'surface-container': '#281b1b',
    'surface-container-high': '#342323',
    'surface-container-highest': '#432d2d',
  },
};
